export type User = {
  id: string
  siengeId: string
  name: string
  cpf: string
  email: string
  isFirstAccess: boolean
  passwordHash: string
  blockListed: boolean
}

export const authState = {
  userEmail: undefined as string | undefined,
  userInfo: undefined as User | undefined,
  authToken: undefined as string,
  refreshToken: undefined as string | undefined,
  changePasswordMsg: undefined as string | undefined,
  currentPassword: undefined as string | undefined,
  uid: undefined as string | undefined,
  userLoading: false,
  shouldScrollLoginScreen: false,
}
